let searchBtn = document.querySelector('.serachBoxInp button');
let searchForm = document.querySelector('#blog-search-form')
let preValue = null;
if(searchForm){
  searchForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    let value = document.querySelector('.serachBoxInp input').value;
    let searchDropDown = document.querySelector('.searchDropDownArea');
    if(!value || value == ''){
      if(searchDropDown.classList.contains('active')){
        searchDropDown.classList.remove('active')
      }
      return;
    }
    if(value == preValue){
      if(!searchDropDown.classList.contains('active')){
        searchDropDown.classList.add('active')
      }
      return ;
    }
    preValue = value;
    if(!searchDropDown.classList.contains('active')){
      searchDropDown.classList.add('active')
    }
    searchDropDown.querySelector('ul').innerHTML = `<li class="searchLoaderArea">
      <div class="searchLoader"></div>
    </li>`;

    let res = await fetch(`/search/suggest.json?q=${value}&resources[type]=article`)
    let data = await res.json()
    if(data.resources && data.resources.results && data.resources.results.articles){
      if(data.resources.results.articles.length == 0){
        // Sorry, we couldn't find any posts. Please try a different search.
        searchDropDown.querySelector('ul').innerHTML = `<li>
          <div class="noDataTxt">
            <p>Sorry, we couldn't find any articles. Please try a different search.</p>
          </div>
        </li>`
      }else{
        let html = '';
        data.resources.results.articles.forEach(article=>{
          let div = document.createElement('div');
          div.innerHTML = article.body;
                
          let fullUrl = article.url;
          let cleanUrl = fullUrl.split('?')[0]; // Extracting the base URL without query parameters

          console.log(cleanUrl)
          // Now use cleanUrl in your HTML template
          html += `<li>
              <a href="${cleanUrl}">
              <div class="searchThumbImg">
                <img loading="lazy" src="${article.featured_image.url}" alt="${article.alt}">
              </div>
              <div class="searchTxtBlock">
                <h4>${article.title}</h4>
                <p>${div.innerText}</p>
              </div>
            </a>
          </li>`
        })
        searchDropDown.querySelector('ul').innerHTML = html
      }
    }

    console.log(value);
  })
  document.addEventListener('click', (e)=>{
    let searchDropDown = document.querySelector('.searchDropDownArea');
    let searchInput = document.querySelector('.serachBoxInp input')
    const isClickInside = searchDropDown.contains(e.target) || searchBtn.contains(e.target) || searchInput.contains(e.target);
    if (!isClickInside) {
      if(searchDropDown.classList.contains('active')){
        searchDropDown.classList.remove('active')
      }
    }
  })
}

let filterSelect = document.querySelector('.blogsCategoryFilter #filter');
filterSelect.addEventListener('change', function() {
let selectedValue = this.value;
if (selectedValue !== '') {
  window.location.href = selectedValue;
}
});